<template>
  <div class="md-layout md-layout-item">
    <div class="md-layout-item md-layout-nowrap md-size-30" style="padding: 0px 5px 0px 7px; min-width: 72px">
      <div style="height: 25px; font-size: 0.72rem" align="Left">
        <span>Sphere:</span>
      </div>
      <div style="height: 25px; font-size: 0.72rem; white-space: nowrap" align="Left">
        <span>Cylinder:</span>
      </div>
      <div style="height: 25px; font-size: 0.72rem" align="Left">
        <span>Axis:</span>
      </div>
      <div style="height: 25px; font-size: 0.72rem" align="Left">
        <span>Add:</span>
      </div>
      <div style="height: 25px; font-size: 0.72rem; white-space: nowrap" align="Left">
        <span>Acuity:</span>
      </div>
      <div v-if="type == 'contacts'">
        <div style="height: 25px; font-size: 0.72rem; white-space: nowrap" align="Left">
          <span>Base Curve:</span>
        </div>
        <div style="height: 25px; font-size: 0.72rem; white-space: nowrap" align="Left">
          <span>Diameter:</span>
        </div>
        <div style="height: 25px; font-size: 0.72rem; white-space: nowrap" align="Left">
          <span>Color:</span>
        </div>
      </div>
    </div>
    <div class="md-layout-item" style="padding: 0px 0px 0px 0px">
      <div
        style="height: 25px; font-size: 0.77rem; color: darkblue; white-space: nowrap; border-bottom: 1px solid #ccc">
        <span> {{ rxValues.SPH }}</span>
      </div>
      <div style="height: 25px; font-size: 0.77rem; color: darkblue; border-bottom: 1px solid #ccc">
        <span>{{ rxValues.CYL }}</span>
      </div>
      <div style="height: 25px; font-size: 0.77rem; color: darkblue; border-bottom: 1px solid #ccc">
        <span>{{ rxValues.AXS }}</span>
      </div>
      <div style="height: 25px; font-size: 0.77rem; color: darkblue; border-bottom: 1px solid #ccc">
        <span>{{ rxValues.POW }}</span>
      </div>
      <div
        style="height: 25px; font-size: 0.77rem; color: darkblue; white-space: nowrap; border-bottom: 1px solid #ccc">
        <span>{{ rxValues.DIS }}</span>
      </div>
      <div v-if="type == 'contacts'">
        <div
          style="height: 25px; font-size: 0.77rem; color: darkblue; white-space: nowrap; border-bottom: 1px solid #ccc">
          <span>{{ rxValues.BC }}</span>
        </div>
        <div
          style="height: 25px; font-size: 0.77rem; color: darkblue; white-space: nowrap; border-bottom: 1px solid #ccc">
          <span>{{ rxValues.DIA }}</span>
        </div>
        <div
          style="height: 25px; font-size: 0.77rem; color: darkblue; white-space: nowrap; border-bottom: 1px solid #ccc">
          <span>{{ rxValues.COL }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import EyeInfoService from "../../../services/eye-info.service"

export default {
  props: ["eye", "type"],
  data() {
    return {
      eyeService: EyeInfoService,
      rxValues: {
        SPH: "",
        CYL: "",
        AXS: "",
        POW: "",
        DIS: "",
        BC: "",
        DIA: "",
        COL: "",
        BRA: "",
        MAN: "",
        QT: ""
      }
    }
  },
  computed: {
    ...mapGetters(["screeningAssets", "medicalInfo"]),
    glassesHistory() {
      return this.medicalInfo.histGlasses
    },
    contactsHistory() {
      return this.medicalInfo.histContacts
    },
    eyeText() {
      return this.eye ? this.eye.toUpperCase() : "OU"
    }
  },
  watch: {
    medicalInfo: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal && (newVal.histGlasses || newVal.histContacts)) {
          this.fillValues()
        }
      }
    }
  },
  methods: {
    fillValues() {
      if (this.type === "glasses") {
        this.fillGlasses()
      } else {
        this.fillContacts()
      }
    },
    fillGlasses() {
      if (!this.glassesHistory) {
        return
      }

      if (this.eye === "od") {
        this.rxValues.SPH = this.eyeService.formatValue(this.glassesHistory.sphereOD, this.eyeService.ValidRanges.SPH)
        this.rxValues.CYL = this.eyeService.formatValue(this.glassesHistory.cylinderOD, this.eyeService.ValidRanges.CYL)
        this.rxValues.AXS = this.eyeService.formatValue(this.glassesHistory.axisOD, this.eyeService.ValidRanges.AXS)
        this.rxValues.POW = this.eyeService.formatValue(this.glassesHistory.powerOD, this.eyeService.ValidRanges.POW)
        const acuityPrefix = this.glassesHistory.distanceOD ? "20/" : ""
        this.rxValues.DIS = acuityPrefix + this.eyeService.formatValue(this.glassesHistory.distanceOD, this.eyeService.ValidRanges.DIS)
      } else {
        this.rxValues.SPH = this.eyeService.formatValue(this.glassesHistory.sphereOS, this.eyeService.ValidRanges.SPH)
        this.rxValues.CYL = this.eyeService.formatValue(this.glassesHistory.cylinderOS, this.eyeService.ValidRanges.CYL)
        this.rxValues.AXS = this.eyeService.formatValue(this.glassesHistory.axisOS, this.eyeService.ValidRanges.AXS)
        this.rxValues.POW = this.eyeService.formatValue(this.glassesHistory.powerOS, this.eyeService.ValidRanges.POW)
        const acuityPrefix = this.glassesHistory.distanceOS ? "20/" : ""
        this.rxValues.DIS = acuityPrefix + this.eyeService.formatValue(this.glassesHistory.distanceOS, this.eyeService.ValidRanges.DIS)
      }
    },
    fillContacts() {
      if (!this.contactsHistory) {
        return
      }

      if (this.eye === "od") {
        this.rxValues.SPH = this.eyeService.formatValue(this.contactsHistory.sphereOD, this.eyeService.ValidRanges.SPH)
        this.rxValues.CYL = this.eyeService.formatValue(this.contactsHistory.cylinderOD, this.eyeService.ValidRanges.CYL)
        this.rxValues.AXS = this.eyeService.formatValue(this.contactsHistory.axisOD, this.eyeService.ValidRanges.AXS)
        this.rxValues.POW = this.eyeService.formatValue(this.contactsHistory.powerOD, this.eyeService.ValidRanges.POW)
        const acuityPrefix = this.contactsHistory.distanceOD ? "20/" : ""
        this.rxValues.DIS = acuityPrefix + this.eyeService.formatValue(this.contactsHistory.distanceOD, this.eyeService.ValidRanges.DIS)
        this.rxValues.BC = this.eyeService.formatValue(this.contactsHistory.baseCurveOD, this.eyeService.ValidRanges.BC)
        this.rxValues.DIA = this.eyeService.formatValue(this.contactsHistory.diameterOD, this.eyeService.ValidRanges.DIA)
        this.rxValues.COL = this.contactsHistory.colorOD
      } else {
        this.rxValues.SPH = this.eyeService.formatValue(this.contactsHistory.sphereOS, this.eyeService.ValidRanges.SPH)
        this.rxValues.CYL = this.eyeService.formatValue(this.contactsHistory.cylinderOS, this.eyeService.ValidRanges.CYL)
        this.rxValues.AXS = this.eyeService.formatValue(this.contactsHistory.axisOS, this.eyeService.ValidRanges.AXS)
        this.rxValues.POW = this.eyeService.formatValue(this.contactsHistory.powerOS, this.eyeService.ValidRanges.POW)
        const acuityPrefix = this.contactsHistory.distanceOS ? "20/" : ""
        this.rxValues.DIS = acuityPrefix + this.eyeService.formatValue(this.contactsHistory.distanceOS, this.eyeService.ValidRanges.DIS)
        this.rxValues.BC = this.eyeService.formatValue(this.contactsHistory.baseCurveOS, this.eyeService.ValidRanges.BC)
        this.rxValues.DIA = this.eyeService.formatValue(this.contactsHistory.diameterOS, this.eyeService.ValidRanges.DIA)
        this.rxValues.COL = this.contactsHistory.colorOS
      }
    }
  }
}
</script>
